import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Api from '../../services/ApiService';
import Socket from '../../services/SocketService';

class ChatMembers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      members: {},
    };

    this.addMember = this.addMember.bind(this);
    this.removeMember = this.removeMember.bind(this);
  }

  componentDidMount() {
    const { room } = this.props;

    this.syncMembers();

    Socket.chat
      .on(`${room}.joined`, this.addMember)
      .on(`${room}.left`, this.removeMember);
  }

  componentWillUnmount() {
    const { room } = this.props;

    Socket.chat
      .off(`${room}.joined`, this.addMember)
      .off(`${room}.left`, this.removeMember);
  }

  addMember({ user }) {
    if (!this.state.members[String(user.id)]) {
      const stateMembers = this.state.members;
      stateMembers[String(user.id)] = user;
      this.setState({ members: stateMembers });
    }
  }

  removeMember({ user }) {
    if (this.state.members[String(user.id)]) {
      const stateMembers = this.state.members;
      delete stateMembers[String(user.id)];
      this.setState({ members: stateMembers });
    }
  }

  syncMembers() {
    Api.get(`chat/room/${this.props.room}/members`).then((res) => {
      const members = {};
      if (res.data.length) {
        res.data.forEach((user) => {
          members[String(user.id)] = user;
        });
      }
      this.setState({ members });
    });
  }

  render() {
    const { members } = this.state;

    const userIds = Object.keys(members);

    return (
      <div className="members">
        <div className="members-head">ONLINE ({userIds.length})</div>
        {userIds.map((userId) => {
          return (
            <div key={`chat-${this.props.room}-${userId}`}>
              {members[userId].username}
            </div>
          );
        })}
      </div>
    );
  }
}

ChatMembers.propTypes = {
  room: PropTypes.string,
};

export default ChatMembers;
